import React, { useState } from "react";
import { Input } from "@/components/ui/input.tsx";
import { Button } from "@/components/ui/button.tsx";
import { updateUser } from "@/api/user_api.ts";
import { useSnapshot } from "valtio/react";
import { loginState } from "@/states.ts";

const ChangeEmailForm: React.FC = (props) => {
	const loginSnap = useSnapshot(loginState);
	const [email, setEmail] = useState(loginSnap.user?.email || "");
	const [password, setPassword] = useState("");
	const [success, setSuccess] = useState(false);
	const [loading, setLoading] = useState(false);

	const handleSubmit = (e: React.SyntheticEvent) => {
		e.preventDefault();

		setLoading(true);
		setSuccess(false);

		updateUser(email, password)
			.then((r) => {
				setSuccess(true);
			})
			.catch((e) => {
				//todo error handling
				console.error(e);
			})
			.finally(() => {
				setLoading(false);
			});
	};

	return (
		<form onSubmit={handleSubmit} target={"#"}>
			<div className={"flex flex-col gap-4 py-2"}>
				<label>
					Change Email
					<Input
						value={email}
						onChange={(e) => setEmail(e.target.value)}
					/>
				</label>
				<label>
					Current Password
					<Input
						type="password"
						value={password}
						onChange={(e) => setPassword(e.target.value)}
					/>
				</label>
				<div>
					<Button
						type="submit"
						onClick={handleSubmit}
						disabled={loading}
					>
						Save
					</Button>
					{success && (
						<div className={"text-green-400"}>Email Saved</div>
					)}
				</div>
			</div>
		</form>
	);
};

export { ChangeEmailForm };
